import { render, staticRenderFns } from "./UpcomingAgreementRenewalWidget.vue?vue&type=template&id=27f6023a&"
import script from "./UpcomingAgreementRenewalWidget.vue?vue&type=script&lang=js&"
export * from "./UpcomingAgreementRenewalWidget.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingAgreementRenewalWidget.vue?vue&type=style&index=0&id=27f6023a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports